import React, { FC, useEffect, useState } from 'react';
import { useIntersect } from '@wix/experts-common';
import TemplateLoadedCard from './TemplateLoadedCard';
import TemplateLoadingCard from './TemplateLoadingCard';
import TemplateCardLinkWrapper from './TemplateCardLinkWrapper';
import { LoadedTemplateCardProps } from './TemplateLoadedCard/TemplateLoadedCard';
import { TemplateGalleryCard } from '../../../types/index';
import { TFunction } from '@wix/fe-essentials-business-manager/dist/types/exports/i18n';
import { TemplateCardLinkWrapperProps } from './TemplateCardLinkWrapper/TemplateCardLinkWrapper';

export interface TemplateCardProps {
  template: TemplateGalleryCard;
  forceRender?: boolean;
  loader?: boolean;
  index: number;
  t: TFunction;
  onClick: () => void;
  templateHref: string | undefined;
  overlayContent?: React.ReactElement;
  CardInfo: LoadedTemplateCardProps['CardInfo'];
  mediaContainerClassName?: LoadedTemplateCardProps['mediaContainerClassName'];
  loadedCardClassName?: LoadedTemplateCardProps['loadedCardClassName'];
  anchorProps?: TemplateCardLinkWrapperProps['anchorProps'];
  showFeatures?: boolean;
  loadingCardHeight?: string;
  loadingSkeletonHeight?: string;
  noBackground?: boolean;
}

const TemplateCard: FC<TemplateCardProps> = ({
  template,
  forceRender,
  loader = false,
  index,
  t,
  onClick,
  templateHref,
  overlayContent,
  CardInfo,
  anchorProps,
  mediaContainerClassName,
  loadedCardClassName,
  showFeatures,
  loadingCardHeight,
  loadingSkeletonHeight,
  noBackground,
}) => {
  const [hover, setHover] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_focused, setFocused] = useState(false);
  const [ready, setReady] = useState(false || forceRender);
  const [ref, entryElement] = useIntersect({}) as any;

  useEffect(() => {
    if (entryElement.intersectionRatio === 1 && !ready && !loader) {
      setTimeout(() => {
        setReady(true);
      }, 200);
    }
  }, [ready, entryElement]);

  return (
    <TemplateCardLinkWrapper
      template={template}
      templateHref={templateHref}
      onClick={onClick}
      setHover={setHover}
      setFocused={setFocused}
      t={t}
      anchorProps={anchorProps}
    >
      {ready ? (
        <TemplateLoadedCard
          template={template}
          setHover={setHover}
          hover={hover}
          index={index}
          overlayContent={overlayContent}
          CardInfo={CardInfo}
          mediaContainerClassName={mediaContainerClassName}
          loadedCardClassName={loadedCardClassName}
          showFeatures={showFeatures}
        />
      ) : (
        <TemplateLoadingCard
          ref={ref}
          componentHeight={loadingCardHeight}
          skeletonHeight={loadingSkeletonHeight}
          noBackground={noBackground}
        />
      )}
    </TemplateCardLinkWrapper>
  );
};

export default TemplateCard;
